angular.module('IndicatorSearch', ['ui.bootstrap']);
